module.exports = __webpack_public_path__ + "img/loader.a96f8702.gif";